import { ENV } from '@/configurations/env';
import { loggerMiddleware } from './logger';
import { logRocketMiddleware } from './logRocket';
import { routerMiddleware } from './routerMiddleware';
import { sagaMiddleware } from './sagaMiddleware';
export var middlewares = [
    {
        fn: sagaMiddleware,
        condition: true,
    },
    {
        fn: routerMiddleware,
        condition: true,
    },
    {
        fn: loggerMiddleware,
        condition: ENV.SHOW_REDUX_LOGGER,
    },
    {
        fn: logRocketMiddleware,
        condition: !!ENV.APP_LOG_ROCKET_ID,
    },
]
    .filter(function (middleware) { return middleware.condition; })
    .map(function (middleware) { return middleware.fn; });
